/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createErrorResponseFromDiscriminatorValue, createInternalErrorResponseFromDiscriminatorValue, createInvoicesPageSummaryFromDiscriminatorValue, type ErrorResponse, type InternalErrorResponse, type InvoicesPageSummary } from '../../../../models/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /api/analytics/invoices/summary
 */
export interface SummaryRequestBuilder extends BaseRequestBuilder<SummaryRequestBuilder> {
    /**
     * The figures in the metric row above the invoice list: the balance outstanding on issued and part- paid invoices, aged by due date (not yet due, 1–30, 31–60 and over 60 days past due); the overdue balance, how many invoices it spans and how many days the oldest is past due; payments received in the last 30 days and the 30 before, net of refunds; and the average days from invoice date to final payment over invoices paid in full in the last 90 days, next to the average net-days term of those invoices where their terms could be read. Invoices that arrive by import carry no payments, so collections and days to pay cover only payments recorded here. Figures may be up to a few minutes old.
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<InvoicesPageSummary>}
     * @throws {ErrorResponse} error when the service returns a 400 status code
     * @throws {InternalErrorResponse} error when the service returns a 500 status code
     */
     get(requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<InvoicesPageSummary | undefined>;
    /**
     * The figures in the metric row above the invoice list: the balance outstanding on issued and part- paid invoices, aged by due date (not yet due, 1–30, 31–60 and over 60 days past due); the overdue balance, how many invoices it spans and how many days the oldest is past due; payments received in the last 30 days and the 30 before, net of refunds; and the average days from invoice date to final payment over invoices paid in full in the last 90 days, next to the average net-days term of those invoices where their terms could be read. Invoices that arrive by import carry no payments, so collections and days to pay cover only payments recorded here. Figures may be up to a few minutes old.
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toGetRequestInformation(requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
/**
 * Uri template for the request builder.
 */
export const SummaryRequestBuilderUriTemplate = "{+baseurl}/api/analytics/invoices/summary";
/**
 * Metadata for all the requests in the request builder.
 */
export const SummaryRequestBuilderRequestsMetadata: RequestsMetadata = {
    get: {
        uriTemplate: SummaryRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            500: createInternalErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createInvoicesPageSummaryFromDiscriminatorValue,
    },
};
/* tslint:enable */
/* eslint-enable */
